import { RESET_STATE } from 'store/global/actions';
import { LOANS_BORROWERS_ACTION_TYPE } from 'store/loans/actions';

const initialState = [];

const loansBorrowersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOANS_BORROWERS_ACTION_TYPE.GET_LOANS_BORROWERS_OPTIONS:
      return payload || initialState;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default loansBorrowersReducer;
